import * as React from 'react';
import { translate } from 'components/translate-hoc';
import { ITranslationProps } from 'types/translation';
import Accordion from 'components/accordion';
import Link from 'components/link';

import { toogleAll } from './faq.utils';
import { IFAQProps } from './faq.types';
import { TEXT_KEYS, FAQ_ANALYTICS } from './faq.constants';
import './faq.styles.less';
import { ICategory, IQuestion } from '@sitegen/common/types/faq';

class FAQ extends React.Component<IFAQProps & ITranslationProps> {
    public state = {
        accordions: [],
        isAllCollapsed: false
    };

    public componentDidMount(): void {
        return this.setState({ accordions: this.props.faqData || [] });
    }

    public onToogleAllClick = (): void => {
        const { isAllCollapsed, accordions } = this.state;
        const newAllCollapsedValue = !isAllCollapsed;

        this.setState({
            isAllCollapsed: newAllCollapsedValue,
            accordions: toogleAll(accordions, newAllCollapsedValue)
        });
    };

    public renderAccordions = () => {
        const { accordions, isAllCollapsed } = this.state;
        const { dangerouslyTranslateWithHTML: translateKey, activeLanguageCode } = this.props;
        return (
            accordions.map(({ title, items }: ICategory, index: number) => (
                <Accordion
                    id={index}
                    key={`${activeLanguageCode}-${index}`}
                    title={translateKey(title)}
                    items={items.map((item: IQuestion) => ({
                        ...item,
                        heading: translateKey(item.heading),
                        panel: translateKey(item.panel),
                        isOpen: item.isOpen || false
                    }))}
                    isAllCollapsed={isAllCollapsed}
                    analyticsAttributes={FAQ_ANALYTICS}
                />
            ))
        );
    };

    public render(): JSX.Element | null {
        const { isAllCollapsed, accordions } = this.state;
        const { dangerouslyTranslateWithHTML: translateKey } = this.props;

        const titleText: string = translateKey(TEXT_KEYS.FAQ_TITLE);
        const expandAllText: string = translateKey(TEXT_KEYS.FAQ_ACTIONS_EXPAND_ALL);
        const collapseAllText: string = translateKey(TEXT_KEYS.FAQ_ACTIONS_COLLAPSE_ALL);

        if (!accordions.length) {
            return null;
        }

        return (
            <div className="sitegen-fr-faq">
                <div className="sitegen-fr-faq__content">
                    <div className="sitegen-fr-faq-hero">
                        <div className="sitegen-fr-faq-hero__title">{titleText}</div>
                        <div className="sitegen-fr-faq-hero__link">
                            <Link onClick={this.onToogleAllClick}>
                                { isAllCollapsed ? collapseAllText : expandAllText }
                            </Link>
                        </div>
                    </div>

                    <div className="sitegen-fr-faq__accordion-wrapper">
                        {this.renderAccordions()}
                    </div>
                </div>
            </div>
        );
    }
}

export default translate()(FAQ);
export {
    FAQ,
    Link,
    Accordion
};
